import cx from "classnames"
import { format } from "date-fns";
import StatusTableDropdown from "components/StatusTableDropdown"
import $ from "jquery"
import React, { useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"
import {
  ACCOUNTS_MANAGER,
  INVOICE_STATES,
  ON_HOLD,
  CANCELLED,
  SURVEYORS_MANAGER,
  CONFIRMED,
  CLIENT_DELAYED,
  GPS_AHD,
  GPS_MGA,
  ADMIN,
  OPERATION_MANAGER,
  stringEllipsis
} from "utils/constants"
import { roleCheck } from "utils/index"
import { useQueryParam, StringParam } from "use-query-params"
import iconAlert from "../../../../../assets/images/icons/icn_alert.svg"
import { getBaseUrl, getCurrentUser, getCurrentRole } from "../../reducers"
import JobServiceSchedulesTableNote from "./JobServiceSchedulesTableNote"
import JobServiceTableBookingTime from "./JobServiceTableBookingTime"
import JobServiceETA from "./JobServiceETA"
import SelectSurveyorButton from "./SelectSurveyorButton"
import AssignmentStartTime from "./AssignmentStartTime";

export default function TableRow({
  rowData, reloadData, bySection, readOnly, isMobileLayout = false
}) {
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const currentRole = useSelector(getCurrentRole)
  const systemRole = currentUser.attributes.role
  const currentTeamRole = currentUser.attributes.current_team_role
  const [showMessage, setShowMessage] = useState(false)
  const [alertType, setAlertType] = useState("error")
  const [alertTitle, setAlertTitle] = useState("")
  const isSurveyorManager = roleCheck(systemRole, currentTeamRole, SURVEYORS_MANAGER)
  const isAccountsManager = roleCheck(systemRole, currentTeamRole, ACCOUNTS_MANAGER)
  const isOperations = roleCheck(systemRole, currentTeamRole, OPERATION_MANAGER)
  const isAdminOrOperations = currentRole?.includes(ADMIN) || isOperations
  const [targetId, setTargetId] = useQueryParam("target_id", StringParam)
  const MOBILE_CELL_CHAR_LIMIT = 15

  const formatScheduleTime = dateValue => (
    isMobileLayout
      ? format(new Date(dateValue), "h:mma")
      : format(new Date(dateValue), "p")
  )

  const {
    attributes: {
      onsite_hours_longer_than_eta: onsiteHoursLongerThanETA,
      surveyor_id: surveyorId,
      allocated_cost: allocatedCost,
      scheduled_at: bookingTime,
      start_at: startAt,
      checked_in_at: assignmentCheckedInAt,
      checked_out_at: assignmentCheckedOutAt,
      onsite_times_as_hours: onsiteTimesAsHours,
      surveyor_booking_valid: surveyorBookingValid,
      has_leave_conflict_after_booking: hasLeaveConflictAfterBooking,
      has_conflicting_assignments: hasConflictingAssignments,
      outside_work_hours: outsideWorkHours,
      required_respond_eta_at: requiredRespondEtaAt,
      disable_required_respond_eta: disableRequiredRespondEta,
      estimated_time_of_arrival: estimatedTimeOfArrival,
      surveyor_not_attend: surveyorNotAttend,
      respond_eta_resolved_at: respondEtaResolvedAt,
      over_time_to_resolve_eta: overTimeToResolveEta,
      job_service: {
        data: {
          id,
          attributes: {
            is_book_in_control_survey: isBookInControlSurvey,
            book_in_job_parent: bookInJobParent,
            is50_50_account: is50_50Account,
            // calculated_total_cost: calculatedTotalCost, // Use for display cost only
            total_cost: totalCost, // Use for invoiceable cost
            label,
            invoice_state: invoiceState,
            client_name: clientName,
            drafted_primary_surveyor_id: draftedPrimarySurveyorId,
            rescheduled_from_id: rescheduledFromId,
            job_address: jobAddress,
            job_id: jobId,
            job_no: jobNo,
            for_project_x: forProjectX,
            project_x_job_no: projectXJobNo,
            job_notes: jobNotes,
            state,
            booking_confirmed: bookingConfirmed,
            operations_notes: operationsNotes,
            pay_before_drafting: payBeforeDrafting,
            collect_payment_onsite_requested: collectPaymentOnsiteRequested,
            job_pack_uploaded: jobPackUploaded,
            checked_in_at: checkedInAt,
            estimated_hours: estimatedHours,
            drafted_primary_surveyor_booking_valid: draftedPrimarySurveyorBookingValid,
            disabled_change_on_schedule: disabledChangeOnSchedule,
            booking_dates: bookingDates,
            confirmation_status: confirmationStatus,
            code,
            awaiting_documents: awaitingDocuments,
            job_details_reviewed: jobDetailsReviewed,
            job_details_approved: jobDetailsApproved,
          }
        }
      }
    },
    id: assignmentId
  } = rowData
  const displayJobNo = forProjectX ? projectXJobNo : jobNo
  const isSurveyorNotAttend = requiredRespondEtaAt && !disableRequiredRespondEta && surveyorNotAttend
  const isFlaggedAsOvertimeResolveETA = requiredRespondEtaAt && !disableRequiredRespondEta && overTimeToResolveEta
  const isResolvedETA = requiredRespondEtaAt && !disableRequiredRespondEta && respondEtaResolvedAt

  let assignmentState = state !== "field_work_ongoing" ? undefined : state
  if (assignmentCheckedInAt && assignmentCheckedOutAt && state === "field_work_ongoing") {
    assignmentState = "field_work_finished"
  }

  useEffect(() => {
    $('[data-toggle="tooltip"]').tooltip()
    return () => {
      $('[data-toggle="tooltip"]').tooltip("dispose")
    };
  }, []);

  // change if the time needs to be update back from the Schedules page again
  const jobService = {
    id,
    attributes: {
      id,
      bookingDates: bookingDates.length > 0 ? bookingDates : [bookingTime],
      jobNotes,
      state,
      operationsNotes,
      jobPackUploaded,
      disabledChangeOnSchedule,
      jobAddress,
      estimatedHours,
      confirmationStatus
    }
  }

  const getParentJobDisplayInvoiceState = () => {
    if (bookInJobParent && bookInJobParent.data) {
      const {
        data: { attributes: parentJobAttributes }
      } = bookInJobParent
      const isParentJobDraftedInvoice = ["deposit_invoice_drafted", "final_invoice_drafted"].includes(parentJobAttributes.invoice_state)

      if (isParentJobDraftedInvoice && parentJobAttributes.pay_before_drafting) return "pay_before_drafting";
      if (isParentJobDraftedInvoice && parentJobAttributes.collect_payment_onsite_requested) return "collect_payment_onsite_requested";

      return parentJobAttributes.invoice_state;
    }

    return "";
  }

  const getDisplayInvoiceState = () => {
    const isDraftedInvoice = ["deposit_invoice_drafted", "final_invoice_drafted"].includes(invoiceState)

    if (isDraftedInvoice && payBeforeDrafting) return "pay_before_drafting";
    if (isDraftedInvoice && collectPaymentOnsiteRequested) return "collect_payment_onsite_requested";

    return invoiceState;
  }

  const onChangeSurveyorFailed = () => {
    setAlertTitle("Ooops! Something went wrong")
    setAlertType("error")
    setShowMessage(true)
  }

  function checkSearchesRequired() {
    const isGpsAhd = (code === GPS_AHD)
    const isGpsMga = (code === GPS_MGA)
    if (isGpsAhd || isGpsMga || jobPackUploaded) {
      return false
    }
    if (is50_50Account && !(payBeforeDrafting || collectPaymentOnsiteRequested || ["paid_deposit", "paid_full"].includes(invoiceState) || Number(totalCost) === 0)) {
      return false
    }
    return true
  }

  const showIconSearchesRequired = checkSearchesRequired()

  const InvoiceStateElement = () => {
    const bookInJobParentData = bookInJobParent?.data || {}
    const { attributes: parentJobAttributes } = bookInJobParentData
    const displayParentJobInvoiceState = getParentJobDisplayInvoiceState()
    const showParentJobInvoiceStatus = isBookInControlSurvey && parentJobAttributes && parentJobAttributes.is50_50_account && Number(parentJobAttributes.total_cost) !== 0
    const parentJobInvoiceStateColor = parentJobAttributes && INVOICE_STATES[displayParentJobInvoiceState]?.bgClass
    const parentJobInvoiceStateText = parentJobAttributes && INVOICE_STATES[displayParentJobInvoiceState]?.text

    const displayInvoiceState = getDisplayInvoiceState()
    const showInvoiceStatus = is50_50Account && Number(totalCost) !== 0
    const invoiceStateColor = INVOICE_STATES[displayInvoiceState]?.bgClass
    const invoiceStateText = INVOICE_STATES[displayInvoiceState]?.text

    return (
      <td className={cx(`dropdown text-center ${showInvoiceStatus ? invoiceStateColor : null} ${showParentJobInvoiceStatus ? parentJobInvoiceStateColor : null} border-left border-white w-100px`)}>
        {(showInvoiceStatus || showParentJobInvoiceStatus) && (
          <button
            className="btn dropdown-toggle"
            type="button">
            { showParentJobInvoiceStatus && (
              <span className="d-inline-block mb-1">
                {`Parent - ${parentJobInvoiceStateText}`}
              </span>
            )}
            { showInvoiceStatus && (
              <span>{invoiceStateText}</span>
            )}
          </button>
        )}
      </td>
    )
  }

  const checkInOverDue = () => {
    if (checkedInAt || state !== CONFIRMED) return false

    return (new Date() - new Date(bookingTime)) / (1000 * 60 * 60) > 2
  }

  const elementClasses = () => {
    const classes = []

    if ([CANCELLED, ON_HOLD, CLIENT_DELAYED].includes(state)) classes.push("greyout")
    else if (checkInOverDue()) classes.push("highlight")
    else if (bookingConfirmed && !surveyorId) classes.push("highlight")
    else if (isSurveyorNotAttend) classes.push("highlight")
    return classes
  }

  const shouldAlarmBookingTimeRed = () => {
    if ((isFlaggedAsOvertimeResolveETA || isResolvedETA) && !assignmentCheckedInAt) return true;
    if (assignmentCheckedInAt && (new Date(assignmentCheckedInAt) > new Date(startAt))) return true;

    return false;
  }

  const getJobIdBackgroundClass = () => {
    if (!isAdminOrOperations) return ""
    
    // Convert to boolean - treat truthy values as true
    const isReviewed = Boolean(jobDetailsReviewed)
    const isApproved = Boolean(jobDetailsApproved)
    
    if (!isReviewed && !isApproved) {
      return "bg-red border-right border-white"
    }
    if (isReviewed && !isApproved) {
      return "bg-coral border-right border-white"
    }
    return ""
  }

  const displayJobTitle = jobAddress?.split("NSW")[0]
  const displayClientName = isMobileLayout
    ? stringEllipsis(clientName, MOBILE_CELL_CHAR_LIMIT, MOBILE_CELL_CHAR_LIMIT)
    : clientName
  const displayProductLabel = isMobileLayout
    ? stringEllipsis(code || label, MOBILE_CELL_CHAR_LIMIT, MOBILE_CELL_CHAR_LIMIT)
    : label

  return (
    <tr
      id={assignmentId}
      style={Number(assignmentId) === Number(targetId) ? { backgroundColor: "rgba(0, 0, 0, 0.075)" } : {}}
      className={elementClasses().join(" ")}
      {...(showIconSearchesRequired ? { "data-toggle": "tooltip", title: "Searches Required" } : {})}>
      <td className={getJobIdBackgroundClass()}>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{displayJobNo}</Link>
      </td>
      <td title={isMobileLayout && clientName?.length > MOBILE_CELL_CHAR_LIMIT ? clientName : undefined}>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{displayClientName}</Link>
      </td>
      <td className="medium-width">
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{displayJobTitle}</Link>
      </td>
      <td
        className={`${awaitingDocuments ? "bg-coral border-right border-white" : ""}`}
        title={isMobileLayout && label && displayProductLabel !== label ? (code ? `${code} — ${label}` : label) : undefined}>
        <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{displayProductLabel}</Link>
      </td>

      {!readOnly && (
        <td className={`${rescheduledFromId ? "bg-coral border-right border-white" : ""} text-right`}>
          <Link to={`/jobs/${jobId}/job_services/${id}`} className="link-no-decoration">{`$${allocatedCost}`}</Link>
        </td>
      )}

      <StatusTableDropdown
        jobService={jobService}
        assignmentState={assignmentState}
        reloadData={reloadData}
        readOnly={readOnly}
        surveyor={surveyorId || draftedPrimarySurveyorId} />

      {(isSurveyorManager || isAccountsManager || !readOnly) && (
        <InvoiceStateElement />
      )}

      <td className={`dropdown pick-surveyor schedules-surveyor-col${(!surveyorBookingValid || !draftedPrimarySurveyorBookingValid || !surveyorId || hasLeaveConflictAfterBooking || hasConflictingAssignments) ? " bg-coral" : " bg-light"}`}>
        <SelectSurveyorButton
          disabled={readOnly || disabledChangeOnSchedule}
          btnClassName="btn-block"
          isMobileLayout={isMobileLayout}
          setTargetId={setTargetId}
          reloadData={reloadData}
          onChangeSurveyorFailed={onChangeSurveyorFailed}
          rowData={rowData}
          hasLeaveConflict={hasLeaveConflictAfterBooking}
          hasConflictingAssignments={hasConflictingAssignments}
          outsideWorkHours={outsideWorkHours} />
      </td>

      <td className={`schedules-booking-time-col bg-${shouldAlarmBookingTimeRed() ? "red" : "light"} text-center`}>
        <span className="d-block">
          { startAt && !Number.isNaN(Date.parse(startAt)) && (
            <AssignmentStartTime
              jobService={jobService}
              isMobileLayout={isMobileLayout}
              reloadData={() => {
                setTargetId(assignmentId)
                reloadData()
              }}
              readOnly={readOnly}
              assignment={rowData} />
          )}
        </span>
        { assignmentCheckedInAt && (
          <span className={isMobileLayout ? "d-block small" : "d-inline-block small transform-translate-y--50"}>
            <i>{isMobileLayout ? `In ${formatScheduleTime(assignmentCheckedInAt)}` : formatScheduleTime(assignmentCheckedInAt)}</i>
          </span>
        )}
        { assignmentCheckedOutAt && (
          <span className={isMobileLayout ? "d-block small" : "d-block small transform-translate-y--75"}>
            <i>{isMobileLayout ? `Out ${formatScheduleTime(assignmentCheckedOutAt)}` : formatScheduleTime(assignmentCheckedOutAt)}</i>
          </span>
        )}
      </td>

      {/* <JobServiceTableBookingTime
        jobService={jobService}
        reloadData={() => {
          setTargetId(assignmentId)
          reloadData()
        }}
        readOnly={readOnly}
        bySection={bySection}
        bookingTime={bookingTime} /> */}

      <td className={`${onsiteHoursLongerThanETA ? "bg-coral" : ""} text-center`}>
        <JobServiceETA
          jobService={jobService}
          reloadData={() => {
            setTargetId(assignmentId)
            reloadData()
          }}
          readOnly={readOnly} />
        { assignmentCheckedInAt && (!!onsiteTimesAsHours || onsiteTimesAsHours.toString() === "0") && (
          <p className="d-block small text-center">
            <i>{onsiteTimesAsHours}</i>
          </p>
        )}
      </td>
      <JobServiceSchedulesTableNote
        rowData={rowData}
        reloadData={() => {
          setTargetId(assignmentId)
          reloadData()
        }}
        readOnly={readOnly} />
      <td className="keep"><Link to={`/jobs/${jobId}/job_services/${id}`}>Details</Link></td>
      <td>{showIconSearchesRequired && (<img src={iconAlert} alt="Searches Required" />)}</td>
      <SweetAlert
        show={showMessage}
        type={alertType}
        title={alertTitle}
        closeOnClickOutside
        allowEscape={false}
        onConfirm={() => setShowMessage(false)} />
    </tr>
  )
}
